module.exports = __webpack_public_path__ + "static/media/6.c3407a51.jpg";